module.exports = __webpack_public_path__ + "static/img/feature-man-4.e6c8860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-man-4.jpg
// module id = M3nq
// module chunks = 0